export const media = {
  /**
   * 选择图片
   * @param props
   */
  choose(props: ChooseImageProps): Promise<FileList> {
    //TODO:取消的问题待处理
    const { fileType: _fileType } = props
    return new Promise<FileList>((resolve, reject) => {
      let fileType = _fileType || "image/*"
      const input = document.createElement("input")
      input.setAttribute("type", "file")
      input.setAttribute("multiple", "multiple")
      input.setAttribute("accept", fileType)
      input.click()
      input.onchange = function () {
        const files = input.files
        resolve(files)
      }
      input.remove()
    })
  },
}
